import styled from 'styled-components';

import { COLORS } from 'styles/style-constants';

export const Illustration = styled.span`
    display: block;
    position: relative;
    width: 11.8rem;
    height: 13rem;
    flex-shrink: 0;

    &::before {
        content: '';
        position: absolute;
        left: 0.9rem;
        top: 1.65rem;
        width: 9.9rem;
        height: 9.7rem;
        border-radius: 3.2rem;
        background: ${COLORS.gray50};
    }

    img {
        display: block;
        position: relative;
        width: 100%;
        height: 100%;
    }
`;
